"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  emailRequired: 'Email address is required',
  emailValid: 'Enter valid email address',
  emailMax: 'Email must not be longer than 64 characters',
  passwordRequired: 'Password is required',
  passwordMin: 'Passwords must be at least 6 characters',
  verifyRequired: 'Please enter valid verification code',
  verifyChar: 'Verification codes must be 6 characters'
};
exports["default"] = _default;